/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import { ETextBlockStatus } from '../../../../components/common/TextBlockStatus/textBlockStatusTypes';
import {
    EWizardAdditionalAccountsFieldList,
    EWizardAdditionalAccountsSteps,
} from '../../../../pages/WizardAdditionalAccounts/wizardAdditionalAccountsConstant';
import { IWizardAdditionalAccountsTranslation } from '../../types/wizards/additionalAccounts';
import { initWizardPropsTranslation } from './initWizardTranslation';

export const initWizardAdditionalAccountsTranslation: IWizardAdditionalAccountsTranslation = {
    ...initWizardPropsTranslation,
    [EWizardAdditionalAccountsSteps.StepSelectParams]: {
        activate: '',
        deactivate: '',
        agreementLabel: '',
        agreementLinkLabel: '',
    },
    [EWizardAdditionalAccountsSteps.StepConfirmation]: {
        activateStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
        },
        deactivateStatus: {
            [ETextBlockStatus.ERROR]: '',
            [ETextBlockStatus.OK]: '',
            [ETextBlockStatus.PARTIALLY]: '',
            [ETextBlockStatus.WARNING]: '',
        },
        onlineCheck: {
            info: '',
            title: '',
        },
        orderErrors: {
            activatePersonalAccountError: '',
            activateContentAccountError: '',
            deactivatePersonalAccountError: '',
            deactivateContentAccountError: '',
        },
        recoveryToList: '',
        removedFromList: '',
        subscriberActivationListTitles: {
            [EWizardAdditionalAccountsFieldList.COST]: '',
            [EWizardAdditionalAccountsFieldList.MSISDN]: '',
            [EWizardAdditionalAccountsFieldList.STATUS]: '',
        },
    },
    validateErrors: {
        activateAccountsWithErrors: '',
        deactivateAccountsWithErrors: '',
        fillNotify: '',
        selectOneSubscribers: '',
    },
    wizardReport: {
        email: '',
        header: '',
        phone: '',
        toSubscribers: '',
        toUser: '',
    },
    wizardSummary: {
        activationAdditionalAccounts: '',
        activationSubscribersAmount: '',
        activationTitle: '',
        activationTotalCost: '',
        deactivationAdditionalAccounts: '',
        deactivationSubscribersAmount: '',
        deactivationTitle: '',
        deactivationTotalCost: '',
        deactivationGetRemainInstruction: '',
    },
    contentAccount: '',
    personalAccount: '',
};
